export function swEmail(sharedModule) {
  /**
   * Directive to be used with ng-model. Validates the email, according to
   * internal softwear standards.
   */
  sharedModule.directive('swEmail', () => {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function postLink(scope, element, attrs, ctrl) {
        if (!ctrl) {
          // we lack ng-model
          return;
        }

        function validate(value) {
          if (!angular.isString(value)) {
            ctrl.$setValidity('email', false);
            return;
          }

          if (value === '') {
            ctrl.$setValidity('email', true);
            return;
          }

          const splitValue = value.split('@');

          if (splitValue.length !== 2) {
            ctrl.$setValidity('email', false);
            return;
          }

          const [user, domain] = splitValue;

          if (domain === 'localhost') {
            ctrl.$setValidity('email', true);
            return;
          }

          if (user.length > 64) {
            ctrl.$setValidity('email', false);
            return;
          }

          const emailRegex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          if (emailRegex.test(value)) {
            ctrl.$setValidity('email', true);
          } else {
            ctrl.$setValidity('email', false);
          }
        }

        ctrl.$formatters.unshift((modelValue) => {
          validate(modelValue);

          return modelValue;
        });

        ctrl.$parsers.unshift((viewValue) => {
          validate(viewValue);

          return viewValue;
        });
      },
    };
  });
}
